export const INTERNAL_ONLY_ROLES = []

export const ADMIN_ONLY_ROLES = [
  'admin', 
  'admin_fake', 
  'wifirst_documents'
]

export const DEFAULT_CONTACT = {
  sf_id: null,
  title: '',
  last_name : '',
  first_name : '',
  email : '',
  salutation : 'M',
  langue: 'fr_FR',
  country: 'fr',
  admin: false,
  internal: false,
  mobile_phone:'',
  phone: '',
  roles: {
    dashboard: true,
    supervision: true,
    statistic_ssid: true
  },
  accounts: [],
  account_ids: {
    parent_ids:  [],
    site_ids: []
  }
}

export const CIVILITIES = [
  {
    value: 'M',
    label: 'Monsieur',
  },
  {
    value: 'Mme',
    label: 'Madame',
  },
]

export const LANGUAGES = [
  {
    value: 'en_US',
    label: 'Anglais',
  },
  {
    value: 'es_ES',
    label: 'Espagnol',
  },
  {
    value: 'fr_FR',
    label: 'Français',
  },
  {
    value: 'de_DE',
    label: 'Allemand',
  },
  {
    value: 'it_IT',
    label: 'Italien',
  },
]

export const COUNTRY = [
  {
    value: 'en',
    label: 'Royaume-Uni',
  },
  {
    value: 'es',
    label: 'Espagne',
  },
  {
    value: 'fr',
    label: 'France',
  },
  {
    value: 'de',
    label: 'Allemagne',
  },
  {
    value: 'it',
    label: 'Italie',
  },
]

export const LANGUAGE_TO_COUNTRY = {
  'fr_FR': 'fr',
  'en_US': 'en', 
  'es_ES': 'es',
  'de_DE': 'de',
  'it_IT': 'it'
}
